// Values consumed by the site's Less files. Bootstrap 5 is loaded as CSS.
@brand-danger: #dc3545;
@btn-border-radius-base: 2px;
@font-family-serif: Georgia, 'Times New Roman', serif;
@grid-float-breakpoint: 768px;
@grid-float-breakpoint-max: 767px;
@grid-gutter-width: 30px;
@input-bg: #fff;
@input-border: #ced4da;
@input-color: #333;
@input-height-large: 46px;
@line-height-base: 1.428571429;
@line-height-large: 1.3333333;
@list-group-active-color: #fff;
@padding-xs-horizontal: 5px;
@padding-xs-vertical: 1px;
@screen-xs: 480px;
@screen-xs-min: 480px;
@screen-xs-max: 767px;
@screen-sm-min: 768px;
@screen-sm-max: 991px;
@screen-md-min: 992px;
@screen-md-max: 1199px;
@screen-lg-min: 1200px;
@text-muted: #6c757d;
@zindex-dropdown: 1000;
@zindex-navbar: 1000;
@zindex-navbar-fixed: 1030;
@zindex-modal: 1055;
@zindex-popover: 1070;
